import React from 'react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { colorSet } from '@components/Provider';
import {
  TextField,
  useTheme,
  useMediaQuery,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      marginBottom: 84,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 100
      }
    },
    displayItem: {
      '& +div': {
        marginTop: 67
      },
      '& .title': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        '& .MuiTypography-root': {
          '& span': {
            fontSize: 14,
            fontWeight: 'normal',
            marginLeft: 12
          }
        }
      },
      '& .MuiTypography-colorTextSecondary': {
        '&:last-child': {
          color: colorSet.gray600
        }
      }
    }
  };
});

interface Props {
  onClick: () => void;
}

const DrawingFilesDetailedInfoPresenter: React.FC<Props> = ({ onClick }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CustomizedTypography
        variant={matches ? 'h3' : 'h2'}
        fontWeight="bold"
        color="textPrimary"
        align="center"
        gutterBottoms={40}
      >
        도면 상세 정보를 입력해주세요
      </CustomizedTypography>
      <div className={classes.displayItem}>
        <CustomizedTypography
          variant="body1"
          fontWeight="500"
          color="textPrimary"
          gutterBottoms={4}
        >
          상세 요청사항 (선택)
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          gutterBottoms={16}
        >
          도면의 치수, 가공 용도, 상세 가공 요청을 파트너에게 알려주세요. 요청
          사항이 상세할수록, 업체로부터 정확한 답변을 받을 확률이 높아집니다
        </CustomizedTypography>
        <TextField
          placeholder=" 공차, 조립성, 도색, 표면 처리등 상세한 가공 요청을 입력해 주세요."
          variant="outlined"
          minRows={4}
          maxRows={4}
          multiline
          fullWidth
          onClick={onClick}
        />
      </div>
      <div className={classes.displayItem}>
        <div className="title">
          <CustomizedTypography
            variant="body1"
            fontWeight="500"
            color="textPrimary"
            gutterBottoms={4}
          >
            상세 요청사항 (선택)<span>총 0개</span>
          </CustomizedTypography>
          <CustomizedButton
            variant="outlined"
            color="primary"
            size="small"
            onClick={onClick}
          >
            파일 첨부
          </CustomizedButton>
        </div>
        <CustomizedTypography
          variant="body2"
          color="textSecondary"
          gutterBottoms={12}
        >
          도면, 프로젝트 이해에 도움이 되는 기타 파일을 첨부해주세요.
        </CustomizedTypography>
        <CustomizedTypography variant="body2" color="textSecondary">
          아직 첨부한 파일이 없습니다.
        </CustomizedTypography>
      </div>
    </div>
  );
};

export default DrawingFilesDetailedInfoPresenter;
